module.exports = __webpack_public_path__ + "static/fonts/Helvetica.63176ce.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Helvetica.woff2
// module id = RujK
// module chunks = 1